/**
 * Environment Configuration
 * 
 * This file provides environment-specific configuration settings.
 * It uses process.env variables that are set during build time.
 */

// Define environment configurations
const environments = {
  development: {
    apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1',
    websocketUrl: process.env.REACT_APP_WEBSOCKET_URL || 'ws://localhost:8001',
    notificationsUrl: process.env.REACT_APP_NOTIFICATIONS_URL || 'http://localhost:8002',
    debug: true,
    logLevel: 'debug',
    enableMocks: process.env.REACT_APP_ENABLE_MOCKS === 'true',
  },
  staging: {
    apiUrl: process.env.REACT_APP_API_URL,
    websocketUrl: process.env.REACT_APP_WEBSOCKET_URL,
    notificationsUrl: process.env.REACT_APP_NOTIFICATIONS_URL,
    debug: true,
    logLevel: 'info',
    enableMocks: false,
  },
  production: {
    apiUrl: process.env.REACT_APP_API_URL,
    websocketUrl: process.env.REACT_APP_WEBSOCKET_URL,
    notificationsUrl: process.env.REACT_APP_NOTIFICATIONS_URL,
    debug: false,
    logLevel: 'error',
    enableMocks: false,
  }
};

// Determine current environment
const env = process.env.REACT_APP_ENV || 'development';

// Create config object with environment settings
const config = {
  ...environments[env],
  isProduction: env === 'production',
  isDevelopment: env === 'development',
  isStaging: env === 'staging',
  env,
  
  // Common settings across all environments
  appName: 'Bitpanel',
  appVersion: process.env.REACT_APP_VERSION || '1.0.0',
  
  // Authentication settings
  authTokenKey: 'userData',
  tokenExpiryTime: 24 * 60 * 60 * 1000, // 24 hours
  
  // Feature flags
  features: {
    enablePushNotifications: process.env.REACT_APP_ENABLE_PUSH_NOTIFICATIONS === 'true',
    enableOfflineMode: process.env.REACT_APP_ENABLE_OFFLINE_MODE === 'true',
    enableNewTradingUI: process.env.REACT_APP_ENABLE_NEW_TRADING_UI === 'true',
    enableP2PTrading: process.env.REACT_APP_ENABLE_P2P_TRADING === 'true',
  },
  
  // API timeouts
  apiTimeout: parseInt(process.env.REACT_APP_API_TIMEOUT || '30000', 10),
  
  // Socket settings
  socketReconnectAttempts: 5,
  socketReconnectInterval: 2000,
};

export default config;